import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle';
import FontAwesome from 'utils/FA';

import {SortableContainer, SortableElement, arrayMove}  from 'react-sortable-hoc';

import { duckify, filterDuck } from "utils/duckify";
import { feeRules  } from '../../ducks';

import FeeGroupListItemTableRowSubsectionRow from './FeeGroupListItemTableRowSubsectionRow';
import FeeGroupFeeModal from './FeeGroupFeeModal';

const FeeGroupListItemTableRowSubsection = ({ feeID, feeRulesData , reorderFeeRulesData }) => {

  const [showFeeModal, setShowFeeModal] = useState(false);
  const [draggableData, setDraggableData] = useState(feeRulesData)

  /* react-sortable-hoc logic begins    */

  const onSortEnd = ({oldIndex, newIndex}) => {
    const newData = arrayMove( draggableData , oldIndex , newIndex );
    const mappedIDs = newData.map( (c)=> c.id);
    const dispatch = reorderFeeRulesData(mappedIDs, feeRulesData)
      .catch( (err) => {
        console.log('err', err);
      });
  };

  /*  react-sortable-hoc logic ends   */

  useEffect(() => {
    setDraggableData(feeRulesData)
  }, [feeRulesData])

  return (
    <React.Fragment>
      <tr>
        <td colSpan="6" className="table-row-subsection">
          <FontAwesome icon={faInfoCircle} />
          <span className="italic">
            &nbsp;
            Fees will be assessed in descending order (drag and drop to reorder).
            If no rule applies, this fee will not appear to families on the form or checklist item.
          </span>

          <section className="fee-row-wrapper">
            <table className="fee-rules-table">
              <thead>
                <tr className="fee-row-data fee-row-header">
                  <th className="fee-rules-table-section-draggable"></th>
                  <th className="fee-rules-table-section-feename">Fee Name</th>
                  <th className="fee-rules-table-section-description">Description</th>
                  <th className="fee-rules-table-section-amount">Amount</th>
                  <th className="fee-rules-table-section-conditions">Conditions</th>
                  <th className="fee-rules-table-section-active">Active</th>
                  <th className="fee-rules-table-section-actionbuttons"></th>
                </tr>
              </thead>
              <SortableList items={draggableData} onSortEnd={onSortEnd} feeID={feeID} lockAxis={'y'}  useDragHandle={true}/>

            </table>
            <div className="add-new-fee-wrapper">
              <a className="add-item-button fee-entity-add" onClick={() => setShowFeeModal(true)}>
                <FontAwesome icon={faPlusCircle} /> Add a new fee
              </a>
            </div>
          </section>
        </td>
      </tr>
      {showFeeModal &&
        <FeeGroupFeeModal closeModal={() => setShowFeeModal(false)} feeGroupId={feeID} />
      }
    </React.Fragment>
  )
}

const mapDucksToProps = ({ feeID }) => {
  return {
    feeRulesData: filterDuck(feeRules, { fee_id: feeID })
  };
};
const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  reorderFeeRulesData : (arr) => {
    return dispatch(feeRules.actions.reorder(arr)).then(() => dispatch(feeRules.actions.markDirty()))
  }
});

FeeGroupListItemTableRowSubsection.propTypes = {
  feeID: PropTypes.string,
  feeRulesData: PropTypes.array
};

export default duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(FeeGroupListItemTableRowSubsection);

const SortableList = SortableContainer(({items, feeID}) => {
  return (
    <tbody>
      {items.map((value, index) => (
        <SortableItem key={`item-${value.id}`} index={index} value={value} feeID={feeID} />
      ))}
    </tbody>
  );
});

SortableList.propTypes = {
  items: PropTypes.array,
  feeID: PropTypes.string
}

const SortableItem = SortableElement(({value, feeID}) => {
  return (
    <tr className="fee-row-data">
      <FeeGroupListItemTableRowSubsectionRow feeData={value} feeID={feeID} />
    </tr>
  )
});

SortableItem.propTypes = {
  value: PropTypes.object,
  feeID: PropTypes.string
}
